export enum DataServiceEventType {
  BUSY = "Busy",
  IDLE = "Idle"
}
